import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './PoemModal.module.css';

const fragments = [
  'que no se dejen comprar,',
  'que mantengan su palabra,',
  'que consideren que el carácter vale más que las riquezas,',
  'que tengan opiniones y voluntad decididas,',
  'que sobrepasen sus profesiones,',
  'que no vacilen en aceptar riesgos,',
  'que no pierdan su individualidad en medio de la multitud,',
  'que sean honestos en los asuntos pequeños como en los más grandes,',
  'que no transijan con la injusticia,',
  'que no tengan ambiciones confinadas a sus propios deseos egoístas,',
  'que no digan que lo hacen “porque todos los demás lo hacen”,',
  'que sean verdaderos amigos para sus amigos en lo bueno y en lo malo, en la adversidad y en la prosperidad,',
  'que no crean que la sutileza, la astucia y la necedad son las mejores cualidades para alcanzar el éxito,',
  'que no se asusten ni se avergüencen de defender la verdad cuando esta no es popular,',
  'que puedan decir “no” enfáticamente, mientras que el resto del mundo dice “sí”.',
];

const PoemModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      // Enfocar el modal al abrir
      modalRef.current?.focus();
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Manejar focus trapping
  useEffect(() => {
    if (!isOpen) return;

    const handleTabKey = (e) => {
      if (e.key !== 'Tab') return;

      const focusableElements = modalRef.current?.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusableElements || focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    };

    document.addEventListener('keydown', handleTabKey);
    return () => document.removeEventListener('keydown', handleTabKey);
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className={styles.overlay} onClick={onClose}>
          <motion.div
            ref={modalRef}
            className={styles.modal}
            role="dialog"
            aria-modal="true"
            aria-labelledby="poem-modal-title"
            tabIndex="-1"
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={styles.closeBtn}
              onClick={onClose}
              aria-label="Cerrar modal"
            >
              <span className="material-symbols-outlined" aria-hidden="true">
                close
              </span>
            </button>

            <div className={styles.content}>
              <div className={styles.header}>
                <span className={styles.preTitle}>Se buscan</span>
                <h2 id="poem-modal-title" className={styles.title}>
                  hombres y mujeres de valor
                </h2>
                <div className={styles.divider}></div>
              </div>

              <div className={styles.poemBody}>
                <ul className={styles.poemList}>
                  {fragments.map((fragment, index) => (
                    <li key={index} className={styles.poemLine}>
                      {fragment}
                    </li>
                  ))}
                </ul>
              </div>

              <div className={styles.footer}>
                <p className={styles.author}>— Anónimo —</p>
                <button className={styles.closeActionBtn} onClick={onClose}>
                  Cerrar
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default PoemModal;
